/*
  LAMIXO "More sizes in similar items" (21 Oct 2026), like Temu.
  Product pages with a Size option: under the size picker, a pill for every
  standard size (same measure as this product) that similar items have in
  stock, including sizes this product has too, small to large; the size
  the shopper has selected is marked. Items
  come from the same category (cat: tag) first, then the department
  (grp: tag), like "Explore LAMIXO picks" on the cart page. Products
  without those tags use their own collections (smallest first). A pill opens a pop-up with size
  tabs and a grid of default LAMIXO cards in that size (quick add works on
  them), 40 at a time with "Show more".
  Data: sections/lamixo-size-sim on a collection, through the Search &
  Discovery Size filter (filter.v.option.size) plus in-stock filter:
  the sizes with their counts, and 40 ready cards per page.
  Styles: assets/lamixo-similar-sizes.css.
*/
(function () {
  if (window.__lmxSim) return;
  window.__lmxSim = 1;
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;
  var HANDLE = decodeURIComponent(m[1]);
  var SIZE_RE = /size|مقاس|尺码/i;
  var ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', '5XL', '6XL', '7XL'];
  var MAX_PILLS = 16;
  var SKIP = ['all', 'frontpage', 'fashion', 'new-in', 'best-selling-items', 'top-rated', 'sale', 'deals'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* "M (32)" -> M, 3XL -> XXXL: one key per real size */
  var ALIAS = { '1XL': 'XL', '2XL': 'XXL', '3XL': 'XXXL', '4XL': 'XXXXL' };
  function key(s) {
    var k = String(s).replace(/\s*\(.*?\)\s*/g, ' ').trim().toUpperCase();
    return ALIAS[k] || k;
  }
  function sortSizes(a) {
    return a.sort(function (x, y) {
      var nx = parseFloat(x), ny = parseFloat(y);
      if (!isNaN(nx) && !isNaN(ny)) return nx - ny;
      var ix = ORDER.indexOf(key(x)), iy = ORDER.indexOf(key(y));
      if (ix > -1 && iy > -1) return ix - iy;
      if (ix > -1) return -1;
      if (iy > -1) return 1;
      return String(x).localeCompare(String(y), undefined, { numeric: true });
    });
  }
  function text(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  }


  /* ---------- data ----------
     Two sources, in order: the category, then the department. Sizes and
     cards come from the store's Size filter, so even rare sizes are one
     request away. */
  var srcs = [], own = {};
  function source(h) { return { h: h, sizes: {} }; }   /* sizes: key -> {raw:[values], n:count} */
  function q(src, page, raws) {
    var u = '/collections/' + encodeURIComponent(src.h) + '?filter.v.availability=1';
    (raws || []).forEach(function (r) { u += '&filter.v.option.size=' + encodeURIComponent(r); });
    return u + '&page=' + page + '&section_id=lamixo-size-sim';
  }
  function parse(t) {
    var mm = t.match(/<script[^>]*lmx-sf[^>]*>([\s\S]*?)<\/script>/), j;
    try { j = mm ? JSON.parse(mm[1]) : null; } catch (e) { j = null; }
    return j;
  }
  function loadSizes(src) {
    return text(q(src, 1)).then(function (t) {
      var j = parse(t);
      if (!j) return;
      j.sizes.forEach(function (v) {
        if (!v[1]) return;
        var k = key(v[0]), e = (src.sizes[k] = src.sizes[k] || { raw: [], n: 0 });
        e.raw.push(v[0]); e.n += v[1];
      });
    });
  }
  /* only standard sizes of the same measure as this product:
     letters (XXS, S, M, XL, 3XL...) or numbers (36, 38.5, 35.5-36).
     Anything else (One-size, M/L, L/XL, Asian One-size) is never shown,
     and a dress never gets shoe sizes. */
  function kind(k) {
    if (ORDER.indexOf(k) > -1) return 'L';
    if (/^\d+(\.\d+)?(-\d+(\.\d+)?)?$/.test(k)) return 'N';
    return '';
  }
  var ownKind = null;
  function sameKind(k) {
    if (ownKind === null) {
      var ks = Object.keys(own), l = 0, n = 0;
      ks.forEach(function (x) { var t = kind(x); if (t === 'L') l++; else if (t === 'N') n++; });
      ownKind = l || n ? (l >= n ? 'L' : 'N') : '';
    }
    return !!ownKind && kind(k) === ownKind;
  }
  /* every standard size other similar items have in stock (own sizes included) */
  function similarSizes() {
    var all = {};
    srcs.forEach(function (s) {
      Object.keys(s.sizes).forEach(function (k) { if (s.sizes[k].n > (own[k] ? 1 : 0)) all[k] = 1; });
    });
    return sortSizes(Object.keys(all).filter(sameKind)).slice(0, MAX_PILLS);
  }

  /* ---------- block under the size picker ---------- */
  var CHEV = '<svg width="9" height="14" viewBox="0 0 9 14" aria-hidden="true"><path d="m2 2 5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var block = null, sizesNow = [], prod = null, sizeIdx = -1, drawn = '';
  /* size of the variant chosen in the theme's picker */
  function selectedSize() {
    var f = document.querySelector('.product-information form[action*="/cart/add"]');
    var i = f && f.querySelector('input[name="id"]');
    if (!i || !prod) return '';
    var v = prod.variants.filter(function (x) { return String(x.id) === String(i.value); })[0];
    return v ? key(v['option' + (sizeIdx + 1)]) : '';
  }
  function anchor() {
    var info = document.querySelector('.product-information');
    if (!info) return null;
    return info.querySelector('variant-picker') || info.querySelector('.variant-picker') ||
      (info.querySelector('form[action*="/cart/add"]') || {}).parentNode || null;
  }
  function place() {
    if (!sizesNow.length) return;
    var a = anchor();
    if (!a) return;
    if (!block) {
      block = document.createElement('div');
      block.className = 'lmx-msz';
      block.innerHTML = '<h3>More sizes in similar items</h3><div class="lmx-msz-p"></div>';
      block.addEventListener('click', function (e) {
        var b = e.target.closest('[data-size]');
        if (b) { e.preventDefault(); openModal(b.getAttribute('data-size')); }
      });
    }
    var sel = selectedSize();
    if (drawn !== sel + '|' + sizesNow.join(',')) {
      drawn = sel + '|' + sizesNow.join(',');
      block.querySelector('.lmx-msz-p').innerHTML = sizesNow.map(function (s) {
        return '<button type="button" data-size="' + esc(s) + '"' + (key(s) === sel ? ' class="is-cur" aria-current="true"' : '') + '>' + esc(s) + CHEV + '</button>';
      }).join('');
    }
    if (block.previousElementSibling !== a || !block.isConnected) a.parentNode.insertBefore(block, a.nextSibling);
  }


  /* ---------- pop-up ---------- */
  var ov = null, cur = null, busy = false, st = null;
  /* st: per-size state - sources in order, the page reached in each,
     handles already shown, total matching */
  function stateFor(size) {
    var k = key(size);
    return {
      k: k, seen: {}, total: 0, si: 0,
      list: srcs.filter(function (s) { return s.sizes[k]; }).map(function (s) { return { src: s, raw: s.sizes[k].raw, page: 0, pages: 1 }; })
    };
  }
  function moreLeft(s) { return s.list.some(function (x) { return x.page < x.pages; }); }
  /* adds cards until `want` new ones are in, category first */
  function fill(want) {
    if (busy || !ov) return Promise.resolve();
    busy = true;
    var s = st, grid = ov.querySelector('.lmx-msz-g'), more = ov.querySelector('.lmx-msz-more');
    more.hidden = true;
    var skel = [];
    for (var i = 0; i < 8; i++) { var sk = document.createElement('div'); sk.className = 'lmx-msz-sk'; grid.appendChild(sk); skel.push(sk); }
    var added = 0;
    function step() {
      if (s !== st || !ov || added >= want) return Promise.resolve();
      var x = s.list.filter(function (y) { return y.page < y.pages; })[0];
      if (!x) return Promise.resolve();
      x.page++;
      return text(q(x.src, x.page, x.raw)).then(function (t) {
        if (s !== st || !ov) return;
        var j = parse(t);
        if (!j) { x.pages = x.page; return step(); }
        x.pages = j.pages || 1;
        s.total = Math.max(s.total, j.total - (own[s.k] ? 1 : 0));
        var d = new DOMParser().parseFromString(t, 'text/html');
        d.querySelectorAll('.lmx-sg a.lmx-card').forEach(function (a) {
          var h = (a.getAttribute('href') || '').split('/products/')[1];
          h = h ? decodeURIComponent(h.split(/[?#]/)[0]) : '';
          if (!h || h === HANDLE || s.seen[h]) return;
          s.seen[h] = 1; added++;
          skel.length ? grid.insertBefore(document.importNode(a, true), skel[0]) : grid.appendChild(document.importNode(a, true));
        });
        return step();
      });
    }
    return step().then(function () {
      skel.forEach(function (k) { k.remove(); });
      if (s !== st || !ov) return;
      var n = Object.keys(s.seen).length;
      if (!grid.children.length) grid.innerHTML = '<p class="lmx-msz-none">No similar items in this size right now.</p>';
      ov.querySelector('.lmx-msz-n').textContent = Math.max(n, s.total) + (moreLeft(s) && n >= s.total ? '+' : '') + ' items';
      more.hidden = !moreLeft(s);
    }).then(function () { busy = false; }, function () { busy = false; });
  }
  function select(size) {
    cur = size; st = stateFor(size); busy = false;
    ov.querySelector('.lmx-msz-sub').textContent = 'in size ' + size;
    ov.querySelectorAll('.lmx-msz-tabs button').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tab') === size); });
    ov.querySelector('.lmx-msz-g').innerHTML = '';
    ov.querySelector('.lmx-msz-n').textContent = '';
    var on = ov.querySelector('.lmx-msz-tabs .is-on');
    if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest', inline: 'center' });
    fill(40);
  }
  function onKey(e) { if (e.key === 'Escape' && !document.querySelector('.lmxqa-ov')) closeModal(); }
  function closeModal() {
    if (!ov) return;
    ov.remove(); ov = null;
    document.documentElement.classList.remove('lmx-msz-lock');
    document.removeEventListener('keydown', onKey);
  }
  function openModal(size) {
    closeModal();
    ov = document.createElement('div');
    ov.className = 'lmx-msz-ov';
    ov.innerHTML =
      '<div class="lmx-msz-d" role="dialog" aria-modal="true" aria-label="Similar items">' +
        '<div class="lmx-msz-h"><div><h3>Similar items <span class="lmx-msz-sub"></span></h3><span class="lmx-msz-n"></span></div>' +
        '<button type="button" class="lmx-msz-x" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>' +
        '<div class="lmx-msz-tabs">' + sizesNow.map(function (s) {
          return '<button type="button" data-tab="' + esc(s) + '">' + esc(s) + '</button>';
        }).join('') + '</div>' +
        '<div class="lmx-msz-body"><div class="lmx-msz-g"></div>' +
        '<div class="lmx-msz-more" hidden><button type="button">Show more</button></div></div>' +
      '</div>';
    document.body.appendChild(ov);
    document.documentElement.classList.add('lmx-msz-lock');
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('.lmx-msz-x')) { closeModal(); return; }
      var t = e.target.closest('[data-tab]');
      if (t) { select(t.getAttribute('data-tab')); return; }
      if (e.target.closest('.lmx-msz-more button')) fill(40);
    });
    select(size);
  }


  /* ---------- start ---------- */
  function start() {
    text('/products/' + encodeURIComponent(HANDLE) + '.js').then(function (t) {
      var p; try { p = JSON.parse(t); } catch (e) { return; }
      var idx = -1;
      (p.options || []).forEach(function (o, i) {
        var n = typeof o === 'string' ? o : o.name;
        if (idx < 0 && SIZE_RE.test(n || '')) idx = i;
      });
      if (idx < 0) return;
      prod = p; sizeIdx = idx;
      p.variants.forEach(function (v) { if (v.available) own[key(v['option' + (idx + 1)])] = 1; });
      if (!Object.keys(own).some(function (k) { return kind(k); })) return;
      var tags = p.tags || [];
      var c = tags.filter(function (t) { return t.indexOf('cat:') === 0; })[0];
      var g = tags.filter(function (t) { return t.indexOf('grp:') === 0; })[0];
      if (c) srcs.push(source(c.slice(4)));
      if (g) srcs.push(source(g.slice(4)));
      /* no cat:/grp: tags: use the product's own collections, smallest first
         (category), then the next bigger one (department) */
      var ready = srcs.length ? Promise.resolve() : text('/products/' + encodeURIComponent(HANDLE) + '?section_id=lamixo-size-sim').then(function (t) {
        var mm = t.match(/<script[^>]*lmx-pcols[^>]*>([\s\S]*?)<\/script>/), cols = [];
        try { cols = mm ? JSON.parse(mm[1]) : []; } catch (e) { cols = []; }
        cols.filter(function (x) { return x.c > 1 && x.c < 20000 && SKIP.indexOf(x.h) < 0; })
          .sort(function (a, b) { return a.c - b.c; }).slice(0, 2)
          .forEach(function (x) { srcs.push(source(x.h)); });
      });
      return ready.then(function () {
        return Promise.all(srcs.map(loadSizes));
      }).then(function () {
        sizesNow = similarSizes();
        if (!sizesNow.length) return;
        place();
        setInterval(place, 600);   /* the theme redraws the variant picker; also follows the chosen size */
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
